<template>
    <div>
        <div class="alert alert-success m-0 t_center" v-if="record.status === 'approved'">
            <span class="pull-right" v-if="record.closed_at">
                {{ record.closed_at | pmlDate('DD/MM/YYYY') }}
                {{ $t('at') }}
                {{ record.closed_at | pmlDate('HH:mm') }}
            </span>
            <h4 class="m-0">
                {{ $t('approved') }} <i class="fa fa-thumbs-up"></i>
            </h4>
        </div>
        <div class="alert alert-danger m-0 t_center" v-if="record.status === 'refused'">
            <span class="pull-right" v-if="record.closed_at">
                {{ record.closed_at | pmlDate('DD/MM/YYYY') }}
                {{ $t('at') }}
                {{ record.closed_at | pmlDate('HH:mm') }}
            </span>
            <h4 class="m-0">
                {{ $t('refused') }} <i class="fa fa-thumbs-down"></i>
            </h4>
        </div>
        <header class="navbar navbar-default p-10 m-b-20 h_auto">
            <div class="row">
                <div class="col-xs-12 t_right clearfix">
                    <a :href="`/my-quotation/${this.$route.params.code}/pdf`" target="_blank" class="btn btn-inverse btn_mobile_block pull-left"><i class="fa fa-save m-r-5"></i> {{ $t('save_pdf') }}</a>
                    <div v-if="record.status === 'sent' && deal.status === 'open'">
                        <a href="#" @click.prevent="approve()" class="btn btn-default btn_mobile_block" v-if="payments.length == 0">
                            <i class="fa fa-thumbs-up"></i> {{ $t('approve') }}
                        </a>
                        <router-link :to="{ name: 'my-quotation.approve', params: {code: this.$route.params.code} }" class="btn btn-default btn_mobile_block" v-else><i class="fa fa-thumbs-up"></i> {{ $t('approve') }}</router-link>
                        <a href="#" @click.prevent="refuse()" class="btn btn-white btn_mobile_block">
                            <i class="fa fa-thumbs-down"></i> {{ $t('refuse') }}
                        </a>
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { approve, refuse } from 'services/my-quotation'

    export default {
        name: 'Header',
        props: [ 'record', 'deal', 'payments' ],
        data () {
            return {
                isApproving: false,
                isRefusing: false
            }
        },
        methods: {
            approve () {
                this.isApproving = true

                approve(this.$route.params.code)
                    .then(response => this.$emit('refresh', response.data))
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isApproving = false })
            },
            refuse () {
                this.isRefusing = true

                refuse(this.$route.params.code)
                    .then(response => this.$emit('refresh', response.data))
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isRefusing = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/my-quotation/components/Header.vue